import { render } from "./ApprovalListForBranch.vue?vue&type=template&id=57814442&scoped=true&ts=true"
import script from "./ApprovalListForBranch.vue?vue&type=script&lang=ts"
export * from "./ApprovalListForBranch.vue?vue&type=script&lang=ts"

import "./ApprovalListForBranch.vue?vue&type=style&index=0&id=57814442&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57814442"]])

export default __exports__